<template>
  <div class="board__wrapper">
    <v-row class="board__column-wrapper">
      <v-col v-for="status in statusList" :key="status" class="board__column" cols="3">
        <div v-if="board[status]">
          <BoardColumnTitle
            :title="status"
            :total="board[status].length"
            :information="$t(`board.columnInfo.${status}`)"
          />

          <BoardCard
            v-for="item in beforeTodayList[status]"
            :column="status"
            :key="item.id"
            :item="item"
          />

          <div class="board__today" v-if="todayList[status].length">
            <h4 class="board__today-title">
              {{ $t('appointment.label.today') }}
            </h4>

            <BoardCard
              v-for="item in todayList[status]"
              :column="status"
              :key="item.id"
              :item="item"
              class="today"
            />
          </div>

          <BoardCard
            v-for="item in afterTodayList[status]"
            :column="status"
            :key="item.id"
            :item="item"
          />
        </div>
      </v-col>
    </v-row>

    <BoardColumnEmptyState :isEmpty="allEmpty" />
  </div>
</template>

<script>
import BoardColumnEmptyState from './BoardColumnEmptyState'
import BoardPendingActions from './BoardPendingActions'
import BoardColumnTitle from './column/BoardColumnTitle'
import BoardCard from './column/card/BoardCard'

import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'BoardColumnView',

  components: {
    BoardColumnEmptyState,
    BoardPendingActions,
    BoardColumnTitle,
    BoardCard,
  },

  props: {
    board: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      statusList: ['OPEN', 'SCHEDULED', 'CANCELED', 'DONE'],
      todayList: { OPEN: [], SCHEDULED: [], CANCELED: [], DONE: [] },
      afterTodayList: { OPEN: [], SCHEDULED: [], CANCELED: [], DONE: [] },
      beforeTodayList: { OPEN: [], SCHEDULED: [], CANCELED: [], DONE: [] },
      today: moment().format('YYYYMMDD'),
      allEmpty: false,
    }
  },

  watch: {
    board() {
      this.statusList.forEach((item) => {
        this.todayList[item] = []
        this.afterTodayList[item] = []
        this.beforeTodayList[item] = []
        this.checkCardLocation(this.board[item], item)
      })

      this.checkEmptyColumns()
    },
  },

  computed: {
    ...mapGetters(['boardLoading', 'boardPendingActions']),
  },

  methods: {
    checkCardLocation(board, column) {
      const reverse = board ? [...board].reverse() : []

      reverse?.map((item) => {
        const itemDate = moment(item.date).format('YYYYMMDD')

        itemDate < this.today && this.beforeTodayList[column].push(item)
        itemDate === this.today && this.todayList[column].push(item)
        itemDate > this.today && this.afterTodayList[column].push(item)
      })
    },

    checkEmptyColumns() {
      let total = 0

      this.statusList.forEach((item) => (total += this.board[item]?.length))
      total >= 1 ? (this.allEmpty = false) : (this.allEmpty = true)
    },
  },
}
</script>
